<table class="table table-bordered table-striped table-hover" id="excel-table">
    <thead class="thead-dark">
        <tr>
            <th translate class="header-float row-float-total row-table-head">
                {{'rmpv.analiseHora.titulo'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.jan'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.fev'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.mar'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.abr'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.mai'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.jun'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.jul'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.ago'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.set'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.out'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.nov'}}
            </th>
            <th translate class="text-right header-float">
                {{'rmpv.analiseHora.meses.dez'}}
            </th>
            <th translate class="text-right header-float">
                Total
            </th>
            <th translate class="text-right header-float">
                % Total
            </th>
            <th translate class="text-right header-float">
                Total {{anoFiltro - 1}}
            </th>
            <th translate class="text-right header-float">
                Total {{anoFiltro - 2}}
            </th>
        </tr>
    </thead>
    <tbody>
        <!-- HORA MO -->
        <tr *ngFor="let categoria of dados.hora_mo.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseHora.totalHorasMOTrabalhadasFaturaveis'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.total_ano | number: '1.0-0'}}</td>
            <td class="text-right dark-row percentual">{{dados.hora_mo.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_mo.total.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- HORA RETRABALHO -->
        <tr *ngFor="let categoria of dados.hora_retrabalho.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- HORA CORTESIA -->
        <tr *ngFor="let categoria of dados.hora_cortesia.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
            <td [translate]="getTranslate(dados.total_horas_trabalhadas.descricao)" class="dark-row row-float-total">
            </td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.total_ano | number: '1.0-0'}}</td>
            <td class="text-right dark-row percentual">{{dados.total_horas_trabalhadas.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_trabalhadas.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- HORA PERDIDA -->
        <tr *ngFor="let categoria of dados.hora_perdida.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
            <td [translate]="getTranslate(dados.total_horas_disponiveis.descricao)" class="dark-row row-float-total">
            </td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.total_ano | number: '1.0-0'}}</td>
            <td class="text-right dark-row percentual">{{dados.total_horas_disponiveis.percentual | percent: '1.1'}}
            </td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_disponiveis.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>

        <!-- HORA TREINAMENTO -->
        <tr *ngFor="let categoria of dados.hora_treinamento.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>

        <!-- HORA LICENCA / FALTA / FÉRIAS -->
        <tr *ngFor="let categoria of dados.hora_licenca_falta_ferias.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
            <td [translate]="getTranslate(dados.total_horas_compradas.descricao)" class="dark-row row-float-total">
            </td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.total_ano | number: '1.0-0'}}</td>
            <td class="text-right dark-row percentual">{{dados.total_horas_compradas.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.total_horas_compradas.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- HORA VENDIDA -->
        <tr *ngFor="let categoria of dados.hora_vendida.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseHora.totalHorasVendidas'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.total_ano | number: '1.0-0'}}</td>
            <td class="text-right dark-row percentual">{{dados.hora_vendida.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right dark-row">{{dados.hora_vendida.total.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- HORA EXTRA -->
        <tr *ngFor="let categoria of dados.hora_extra.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_02 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_03 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_04 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_05 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_06 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_07 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_08 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_09 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_10 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_11 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.mes_12 | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano | number: '1.0-0'}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | number: '1.0-0'}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | number: '1.0-0'}}</td>
        </tr>
        <!-- PREÇO MO -->
        <tr *ngFor="let categoria of dados.preco_mo.linhas">
            <td [translate]="getTranslate(categoria.descricao)" class="row-float"></td>
            <td class="text-right">{{categoria.mes_01 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_02 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_03 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_04 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_05 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_06 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_07 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_08 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_09 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_10 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_11 | currency:' '}}</td>
            <td class="text-right">{{categoria.mes_12 | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano | currency:' '}}</td>
            <td class="text-right percentual">{{categoria.percentual | percent: '1.1'}}</td>
            <td class="text-right">{{categoria.total_ano_anterior | currency:' '}}</td>
            <td class="text-right">{{categoria.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <tr>
            <td translate class="dark-row row-float-total">{{'rmpv.analiseHora.precoObtidoMoTotal'}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_01 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_02 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_03 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_04 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_05 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_06 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_07 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_08 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_09 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_10 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_11 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.mes_12 | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.total_ano | currency:' '}}</td>
            <td class="text-right dark-row percentual">{{dados.preco_mo.total.percentual | percent: '1.1'}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.total_ano_anterior | currency:' '}}</td>
            <td class="text-right dark-row">{{dados.preco_mo.total.total_ano_retrasado | currency:' '}}</td>
        </tr>
        <tr>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
            <td>...</td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
        </tr>
    </tbody>
</table>